module.exports = __webpack_public_path__ + "img/twitter.0d4dd642.svg";